import {createContext} from "react";

const AddApplicationContext = createContext({});

export default AddApplicationContext;